import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from './AuthContext';
import { PS } from '../theme';
import { Wordmark } from '../lib/ui';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || '';
    const sessionId = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
    if (!sessionId) { navigate('/'); return; }
    (async () => {
      try {
        const res = await api.post('/auth/session', { session_id: sessionId });
        setUser(res.data.user);
        window.history.replaceState(null, '', '/app');
        navigate('/app', { replace: true, state: { user: res.data.user } });
      } catch {
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, background: PS.page }}>
      <Wordmark size={28} />
      <div className="ps-live-dot" style={{ fontSize: 13, color: PS.textMuted }}>กำลังเข้าสู่ระบบ…</div>
    </div>
  );
}
